import { render, staticRenderFns } from "./LinkBlock.vue?vue&type=template&id=b21c08a2&"
import script from "./LinkBlock.vue?vue&type=script&lang=ts&"
export * from "./LinkBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports